import state from './companyProfile/state';
import actions from './companyProfile/actions';

export default {
  ...state,
  ...actions
};
